import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import Skeleton from '@material-ui/lab/Skeleton';
import { Spacings } from '@styles/index';

const Flex = styled.div`
  display: flex;
`;

const Wrapper = styled(Flex)`
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  padding: 0 ${Spacings.SPACING_4B};
  height: 100%;
  flex-direction: column;
  justify-content: center;
`;

const RectWithMargin = styled(Skeleton)`
  margin-top: ${({ $marginTop }) => $marginTop || 0};
  margin-bottom: ${({ $marginBottom }) => $marginBottom || 0};
  margin-left: ${({ $marginLeft }) => $marginLeft || 0};
  transform: scale(1, 1);
  background: var(--color-divider);
  border-radius: ${({ variant }) =>
    variant !== 'circular' ? Spacings.SPACING_2B : '100%'};
`;

const AuthorContainer = styled(Flex)`
  margin-top: ${Spacings.SPACING_3B};
  align-items: center;
`;

const EventSkeleton = ({ showAuthor, showTitle }) => {
  return (
    <Wrapper>
      {showTitle && (
        <RectWithMargin
          width={94}
          height={8}
          $marginBottom={Spacings.SPACING_4B}
          animation={false}
        />
      )}
      <RectWithMargin width={172} height={8} animation={false} />
      <RectWithMargin
        width={172}
        height={8}
        $marginTop={Spacings.SPACING_1B}
        animation={false}
      />
      {showAuthor && (
        <AuthorContainer>
          <RectWithMargin
            variant="circular"
            animation={false}
            height={20}
            width={20}
          />
          <RectWithMargin
            width={94}
            height={8}
            $marginLeft={Spacings.SPACING_3B}
            animation={false}
          />
        </AuthorContainer>
      )}
    </Wrapper>
  );
};

EventSkeleton.propTypes = {
  showAuthor: PropTypes.bool,
  showTitle: PropTypes.bool
};

EventSkeleton.defaultProps = {
  showAuthor: false,
  showTitle: true
};

export default EventSkeleton;
